// Employee/Views/WeekView.tsx
import React from "react";
import {Box} from "@mui/material";
import {WeekViewTable} from "../components/View/WeekViewTable";
import {styles} from "../styles/WeekViewStyles";
import {Event, EventAddData} from "../types";
import {Moment} from "moment";

interface WeekViewProps {
    events: Event[];
    currentWeekStart: Date;
    setEvents: React.Dispatch<React.SetStateAction<Event[]>>;
    editingEvent: Event | null;
    handleEventEdit: (event: Event | null) => void;
    canEdit: boolean;
    userType: "client" | "psychologist" | "observer";
    toggleUserType: () => void;
    handleEventAdd: (eventData: EventAddData) => void;
    onRemove: (event: Event) => void;
    handleCreateAvailability: (start: Date, end: Date) => void;
    showHorizontalLines: boolean;
    showVerticalLines: boolean;
    maxDaysForSelection: number;
    onConfirmSlot?: (slot: Moment) => void;
    timeZone: string;
}

const WeekView: React.FC<WeekViewProps> = ({
                                               events,
                                               currentWeekStart,
                                               handleEventEdit,
                                               canEdit,
                                               userType,
                                               handleEventAdd,
                                               onRemove,
                                               handleCreateAvailability,
                                               showHorizontalLines,
                                               showVerticalLines,
                                               maxDaysForSelection,
                                               onConfirmSlot,
                                               timeZone
                                           }) => {
    return (
        <Box sx={styles.wrapper}>
            <WeekViewTable
                events={events}
                currentWeekStart={currentWeekStart}
                onEdit={handleEventEdit}
                onAdd={handleEventAdd}
                userType={userType}
                canEdit={canEdit}
                onRemove={onRemove}
                onCreateAvailability={handleCreateAvailability}
                showHorizontalLines={showHorizontalLines}
                showVerticalLines={showVerticalLines}
                maxDaysForSelection={maxDaysForSelection}
                onConfirmSlot={onConfirmSlot}
                timeZone={timeZone}
            />
        </Box>
    );
};

export default WeekView;
